import { render } from "./PlaylistSection.vue?vue&type=template&id=1f2dc235"
import script from "./PlaylistSection.vue?vue&type=script&lang=js"
export * from "./PlaylistSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__